'use strict';

angular.module('user').controller('UserSignupController', [
    '$q',
    'AccountManager',
    'ShareCrfUrl',
    'ShareCrfApiErrorCodes',
    'ShareCrfLanguageService',
    'ShareCrfCountries',
    function(
        $q,
        AccountManager,
        ShareCrfUrl,
        ShareCrfApiErrorCodes,
        ShareCrfLanguageService,
        ShareCrfCountries
    ) {
        var vm = this;

        vm.countriesOptions = ShareCrfCountries.getOptions(true);

        vm.$onInit = function() {
            // GARU-5384 Solamente se admiten invitaciones pendientes sin asignar; en otro caso, se muestra un error
            vm.errorInvitation = vm.invitation && (vm.invitation.status !== 'pending' || !!vm.invitation.userId)

            var invitationData = vm.invitation && vm.invitation.id ? _.pick(vm.invitation, ['email', 'name', 'lastname']) : {};

            vm.data = _.merge({
                country: '',
                language: ShareCrfLanguageService.getCurrentLanguageCode(),
                newsletter: true,
            }, invitationData);

            vm.repeatedPassword = '';

            vm.submitted = false;
            vm.running = false;

            vm.error = false;

            vm.showPromoCode = !vm.invitation || !vm.invitation.id;

            var urlWeb = ShareCrfUrl.getWww();
            var links = {
                terms: {
                    es: 'es/terminos-uso-servicio',
                    en: 'terms-use-service',
                },
                privacy: {
                    es: 'es/politica-privacidad',
                    en: 'privacy-policy',
                },
            };
            vm.getPrivacyPolicyLink = function() {
                var lang = ShareCrfLanguageService.getLanguage();

                return urlWeb + links.privacy[lang.code || 'en'];
            };
            vm.getTermsOfUseLink = function () {
                var lang = ShareCrfLanguageService.getLanguage();

                return urlWeb + links.terms[lang.code || 'en'];
            };

            /**
             * Submit form
             *
             * @param {Form}
             *
             * @return {Promise}
             */
            vm.submit = function(form) {
                vm.submitted = true;
                vm.error = false;

                var promise = $q.resolve();

                if (form.$valid) {
                    vm.running = true;

                    var data = _.clone(vm.data);
                    if (vm.invitation && vm.invitation.id) {
                        data.invitationCode = vm.invitation.code;
                    }

                    promise = AccountManager.register(data)
                        .then(function(userProfile) {
                            vm.running = false;

                            if (userProfile.status == 'pending') {
                                return vm.onPendingSignUp({
                                    userProfile: userProfile,
                                });
                            } else {
                                return vm.onActiveSignUp({
                                    userProfile: userProfile,
                                });
                            }
                        })
                        .catch(function(error) {
                            vm.running = false;
                            vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                        });
                }

                return promise;
            };

            /**
             * Check password
             *
             * @param  {String}  value Confirmation value
             *
             * @return {Boolean}       TRUE if password is equal to confirmation value
             */
            vm.checkPassword = function(value) {
                return vm.data.password === value;
            };
        };
    }]);
